import { updateKeyInStore } from 'App';
import {
  FieldArrayKeysKeys,
  updateKey,
  UsCorpOrPartnershipStateValues,
} from '../slice';

export const uploadFields: IBaseField<
  keyof UsCorpOrPartnershipStateValues | FieldArrayKeysKeys
>[] = [
  {
    name: 'pleaseUploadDocumentShowingCorporateDetailsDateOfIncorporationAndShareOwnershipForAllShareholders',
    label:
      'Please upload document showing corporate details, date of incorporation, and share ownership for all shareholders',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.corporationTrust.usCorpOrPartnership.values.wantUsToPrepareCorporateReturn',
  },
  {
    name: 'pleaseUploadCorporationBalanceSheet',
    label: 'Please upload Corporation balance sheet',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.corporationTrust.usCorpOrPartnership.values.wantUsToPrepareCorporateReturn',
  },
  {
    name: 'pleaseUploadTheCorporationsIncomeStatement',
    label: "Please upload the corporation's Income Statement",
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.corporationTrust.usCorpOrPartnership.values.wantUsToPrepareCorporateReturn',
  },
  {
    name: 'copyOfLastFiledFormCorporateTaxReturnifWasFilderBefore',
    label:
      'Copy of last filed form corporate tax return (if was filder before)',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.corporationTrust.usCorpOrPartnership.values.wantUsToPrepareCorporateReturn',
  },
  {
    name: 'pleaseUploadCopyOfFiledForm2553',
    label: 'Please upload copy of filed Form 2553',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.corporationTrust.usCorpOrPartnership.values.haveYouFiledForm1120SBefore',
  },
];
